import { EmbedConfig } from '@cpd-app/generated';

export const powerbiFeatureKey = 'powerbi';

// allow loading of multiple powerbi reports in the future
export type reportKey = 'analytics';

export interface PowerBiState {
  reports: Record<reportKey, EmbedConfig>;
  error: string | null;
}

export const initialPowerBiState: PowerBiState = {
  reports: {
    analytics: null,
  },
  error: null,
};
